import { gql } from "@apollo/client";

const UPDATE_HONORARIOS_PROFESIONAL = gql`
    mutation updateHonorariosProfesional($idsEvaluacionProfesional: [Int!]!){
        updateHonorariosProfesional(idsEvaluacionProfesional: $idsEvaluacionProfesional) {
            idEvaluacionProfesional
        }
    }
`;

export default UPDATE_HONORARIOS_PROFESIONAL;